export default __webpack_public_path__ + "static/media/POSTER 2.2912223f.JPG";